import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Form, Button, Alert } from "react-bootstrap";
import { ThemeContext } from "../context/ThemeContext"; // importa il context
import orderService from "../services/orderService";


const Registrazione = () => {
  const navigate = useNavigate();
  const { darkMode } = useContext(ThemeContext);
  const [form, setForm] = useState({
    nome_azienda: "",
    nome_referente: "",
    telefono: "",
    email: ""
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);


  // Nuovo handleSubmit che usa orderService.richiestaIscrizionePanificatore
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validazione semplice
    for (const key in form) {
      if (!form[key].trim()) {
        setError("Tutti i campi sono obbligatori.");
        return;
      }
    }
    setError("");
    try {
      await orderService.richiestaIscrizionePanificatore(form);
      setSuccess(true);
      setTimeout(() => {
        navigate("/login");
      }, 1500);
    } catch (err) {
      setError("Errore nell'invio della richiesta. Riprova.");
    }
  };

  return (
    <div className={`main-layout ${darkMode ? 'bg-dark' : 'bg-light'}`}>
    <Container 
      className="d-flex flex-column justify-content-center align-items-center" 
      style={{ minHeight: "70vh", marginTop: "80px" }}>
      <Form onSubmit={handleSubmit} 
        className={`p-4 shadow rounded ${darkMode ? "bg-dark text-light" : "bg-white"}`}        style={{ maxWidth: "500px", width: "100%" }}>
        <h2 className="text-center mb-4">Registrazione Nuova Azienda</h2>
        {error && <Alert variant="danger">{error}</Alert>}
        {success && <Alert variant="success">Richiesta inviata! Verrai reindirizzato al login...</Alert>}
        {/* Campi ridotti come richiesto */}
        <Form.Group className="mb-3">
          <Form.Label>Nome Azienda <span className="text-danger">*</span></Form.Label>
          <Form.Control name="nome_azienda" value={form.nome_azienda} onChange={e => setForm({ ...form, nome_azienda: e.target.value })} required autoFocus />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Persona di riferimento <span className="text-danger">*</span></Form.Label>
          <Form.Control name="nome_referente" value={form.nome_referente} onChange={e => setForm({ ...form, nome_referente: e.target.value })} required />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Telefono <span className="text-danger">*</span></Form.Label>
          <Form.Control name="telefono" value={form.telefono} onChange={e => setForm({ ...form, telefono: e.target.value })} required />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Email <span className="text-danger">*</span></Form.Label>
          <Form.Control type="email" name="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
        </Form.Group>
        <Button type="submit" variant="primary" className="w-100 mb-2">
          Invia richiesta
        </Button>
        <Button variant="secondary" className="w-100" onClick={() => navigate("/login")}>Torna al Login</Button>
      </Form>
    </Container>
    </div>
  );
};

export default Registrazione;
